import React from 'react'
import Breadcrumb from '../common/Breadcrumb'

const Club = () => {
  return (
    <>
      <Breadcrumb 
        pageTitle="Club"
        breadcrumbItems={[
          { label: "Home", link: "/" },
          { label: "Club" }
        ]}
        backgroundImage="images/banner/slide-2.png"
      />
      
      <section className="space-ptb">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-12">
              <div className="section-title mb-4 pr-lg-5 px-4 px-lg-2">
                <h2 className="title">
                  <span className="text-primary">Club</span>
                </h2>
                <div className="curved-line mx-auto mt-3"></div>
              </div>  

              <div className="clubs-intro">
                <h3>Explore Your Interests</h3>
                <p>Join our diverse range of clubs and discover new talents, make friends, and develop skills beyond the classroom.</p>
              </div>

              <div className="clubs-grid">
                <div className="club-card">
                  <div className="club-icon">🌳</div> 
                  <h4>Sports Club</h4>
                  <p>Learn about environmental conservation and participate in green initiatives to make our planet better.</p>
                </div>

                <div className="club-card">
                  <div className="club-icon">🪔</div>
                  <h4>Cultural Club</h4>
                  <p>Expand your general knowledge through quizzes, discussions, and interactive learning sessions.</p>
                </div>

                <div className="club-card">
                  <div className="club-icon">✍️</div> 
                  <h4>Art Club</h4>
                  <p>Explore the world of literature through reading, writing, poetry, and creative storytelling.</p>
                </div>

                <div className="club-card">
                  <div className="club-icon">🔬</div>
                  <h4>Science Club</h4>
                  <p>Capture moments and learn the art of photography through hands-on practice and workshops.</p>
                </div>

                <div className="club-card">
                  <div className="club-icon">🎨</div>
                  <h4>Eco Club</h4>
                  <p>Express your creativity through various art forms, painting techniques, and artistic projects.</p>
                </div>

                <div className="club-card">
                  <div className="club-icon">🎤</div> 
                  <h4>Health Club</h4>
                  <p>Discover your musical talents and learn various dance forms in a fun, supportive environment.</p>
                </div>

                <div className="club-card">
                  <div className="club-icon">🌐</div> 
                  <h4>WLiterary Club (English)</h4>
                  <p>Learn modern web technologies and create amazing websites and digital experiences.</p>
                </div>

                <div className="club-card">
                  <div className="club-icon">🎭</div>
                  <h4>Literary Club (Hindi)</h4>
                  <p>Develop confidence and acting skills through theatrical performances and stage productions.</p>
                </div>

                {/* Uncomment अगर Yoga Club जोड़ना हो
                <div className="club-card">
                  <div className="club-icon">🧘‍♀️</div>
                  <h4>Yoga Club</h4>
                  <p>Practice mindfulness, improve flexibility, and learn stress management through yoga and meditation.</p>
                </div> */}
              </div>

              <div className="join-section">
                <h3>Ready to Join?</h3>
                <p>Contact your class teacher or visit the school office to learn more about club activities and enrollment.</p>
                <div className="contact-info">
                  <p><strong>Club Coordinator:</strong> Activities Department</p>
                  <p><strong>Meeting Times:</strong> After school hours and weekends</p>
                </div>
              </div>          
            </div>          
          </div>
        </div>
      </section>
    </>
  )
}

export default Club